import { get } from '../api.service';

export interface EmployeeHolidaySavingsRecord {
    invoiceId: number,
    invoiceNumber: number,
    holidaySavingsAmount: number,
    createdDate: string,
    userId: number,
    employeeName: string | null
}

export interface HolidaySavingsParams {
    PageNumber: number;
    PageSize: number;
    fromDate?: string;
    toDate?: string;
}

export interface HolidaySavingsResponse {
    statusCode: number;
    message: string;
    response: EmployeeHolidaySavingsRecord[];
    totalCount?: number;
    numberOfPages?: number;
}

/**
 * Fetches all employee holiday savings amounts with pagination and date filtering.
 * Corresponds to: GET /salary/getall-employee-holidaysavings-amount?PageNumber=1&PageSize=10&fromDate=2025-10-01&toDate=2025-12-09
 * @param params - The request parameters containing PageNumber, PageSize, fromDate, and toDate.
 * @returns The API response with holiday savings data.
 */
export const fetchEmployeeHolidaySavingsAmount = async (
    params: HolidaySavingsParams
): Promise<HolidaySavingsResponse> => {
    try {
        const queryParams: any = {
            PageNumber: params.PageNumber,
            PageSize: params.PageSize,
        };

        if (params.fromDate) {
            queryParams.fromDate = params.fromDate;
        }

        if (params.toDate) {
            queryParams.toDate = params.toDate;
        }

        const response = await get('/salary/getall-employee-holidaysavings-amount', queryParams);
        return response;
    } catch (error) {
        console.error('Error fetching employee holiday savings amount:', error);
        throw error;
    }
};
